import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { tokenStorage, type AuthTokens } from '@shared/api';
import { ROUTES } from '@shared/config/routes';
import { useSessionStore } from '@entities/session';
import { authApi } from '../api/auth-api';

export function applyTokens(tokens: AuthTokens): void {
  useSessionStore.getState().setSession(tokens);
}

export async function refreshTokens(): Promise<AuthTokens | null> {
  const refreshToken = tokenStorage.getRefresh();
  if (!refreshToken) return null;
  try {
    const tokens = await authApi.refresh(refreshToken);
    applyTokens(tokens);
    return tokens;
  } catch {
    useSessionStore.getState().clear();
    return null;
  }
}

export function useLogout(): () => Promise<void> {
  const navigate = useNavigate();
  return useCallback(async () => {
    const refresh = tokenStorage.getRefresh();
    try {
      if (refresh) await authApi.logout(refresh);
    } catch {
      // server-side logout failure is non-fatal; clear local state anyway
    }
    useSessionStore.getState().clear();
    navigate(ROUTES.login, { replace: true });
  }, [navigate]);
}
